import { render, staticRenderFns } from "./EditInventoryConsumableDrawer.vue?vue&type=template&id=041fb8db"
import script from "./EditInventoryConsumableDrawer.vue?vue&type=script&lang=js"
export * from "./EditInventoryConsumableDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports